// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('bc_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('bc_token');
    if (token) {
      getMe()
        .then(r => { setUser(r.data); localStorage.setItem('bc_user', JSON.stringify(r.data)); })
        .catch(() => { localStorage.removeItem('bc_token'); localStorage.removeItem('bc_user'); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const signIn = (token, userData) => {
    localStorage.setItem('bc_token', token);
    localStorage.setItem('bc_user', JSON.stringify(userData));
    setUser(userData);
  };

  const signOut = () => {
    localStorage.removeItem('bc_token');
    localStorage.removeItem('bc_user');
    setUser(null);
  };

  // Permission check used to gate UI. Super admins implicitly pass everything.
  // Mirrors the backend engine — the backend still enforces on every request,
  // this only decides what to render.
  const can = (permKey) => {
    if (!user) return false;
    if (user.is_super_admin) return true;
    return Array.isArray(user.permissions) && user.permissions.includes(permKey);
  };

  // True if the user holds any of the given permission keys (handy for nav/pages
  // that surface several actions).
  const canAny = (...keys) => keys.flat().some(k => can(k));

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut, can, canAny }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
